import { Checkbox, ListItem, ListItemButton, Stack, Typography } from '@mui/material';
import { VisitorGroup } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { AddUsersToGroupsSelectionState, getGroupSelectionState } from './addUsersToGroupsUtils';

export interface GroupListItemProps {
  visitorGroup: VisitorGroup;
  selectedUserIds: string[];
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const GroupListItem: React.FC<GroupListItemProps> = ({ visitorGroup, selectedUserIds, checked, onChange }) => {
  const { translation } = useTranslation();
  const { state } = getGroupSelectionState(visitorGroup, selectedUserIds);
  const isDisabled = state !== AddUsersToGroupsSelectionState.Available;

  const statusLabels: Partial<Record<AddUsersToGroupsSelectionState, string>> = {
    [AddUsersToGroupsSelectionState.AlreadyAssigned]: translation.selection_already_in_group,
    [AddUsersToGroupsSelectionState.LimitReached]: translation.group_is_full
  };
  const statusLabel = statusLabels[state];

  return (
    <ListItem disablePadding sx={{ backgroundColor: (theme) => theme.custom.background.level2, borderRadius: 1 }}>
      <ListItemButton disabled={isDisabled} onClick={() => onChange(!checked)} sx={{ borderRadius: 1, py: 0 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%" minWidth={0}>
          <Typography noWrap sx={{ minWidth: 0 }}>
            {visitorGroup.name}
          </Typography>
          {statusLabel && (
            <Typography variant="body2" color="text.secondary" noWrap sx={{ ml: 2, flexShrink: 0 }}>
              {statusLabel}
            </Typography>
          )}
        </Stack>

        <Checkbox
          id={`user-group-${visitorGroup.id}-checkbox`}
          checked={checked || state === AddUsersToGroupsSelectionState.AlreadyAssigned}
          disabled={isDisabled}
          disableRipple
          tabIndex={-1}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default GroupListItem;
